var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"spinner"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning","large":""}}),(_vm.message.length > 0)?_c('h3',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }